import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4zm-2 7v-3l-4 4 4 4v-3h12v-2H8z"
}), 'FormatTextdirectionRToLSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FormatTextdirectionRToLSharp.js
// module id = 3907
// module chunks = 2